/**
 * Mock data for Rastreabilidade por Lote
 * 
 * TODO: Replace with API calls to backend when ready
 * Endpoints expected:
 * - GET /api/rastreabilidade/lotes?empresaId=X&periodo=...&lote=...
 * - GET /api/rastreabilidade/xml/download?chaves=...
 */

// Helper function to generate dates
const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  const year = result.getFullYear();
  const month = String(result.getMonth() + 1).padStart(2, '0');
  const day = String(result.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Get today's date in YYYY-MM-DD format (local timezone)
const today = (() => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
})();

export const mockTraceItems = [
  // Empresa 1 - TillBill Tecnologia
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231012345678000190550010000123451000123456',
    nNf: '12345',
    serie: '1',
    emissao: addDays(today, -15),
    cnpjEmitente: '98.765.432/0001-10',
    fornecedorNome: 'Distribuidora Pharma ABC',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'DIPIRONA SODICA 500MG 10 COMP',
    ncm: '30049099',
    cEAN: '7896658019012',
    lote: 'ABC-123',
    dFab: addDays(today, -180),
    dVal: addDays(today, 15),
    qCom: 100,
    uCom: 'CX',
    vProd: 450.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 450.00,
    vIcms: 81.00,
  },
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231012345678000190550010000123451000123456',
    nNf: '12345',
    serie: '1',
    emissao: addDays(today, -15),
    cnpjEmitente: '98.765.432/0001-10',
    fornecedorNome: 'Distribuidora Pharma ABC',
    ufEmitente: 'SP',
    nItem: 2,
    xProd: 'PARACETAMOL 750MG 20 COMP',
    ncm: '30049099',
    cEAN: '7896658019029',
    lote: 'ABC-123A',
    dFab: addDays(today, -175),
    dVal: addDays(today, 45),
    qCom: 50,
    uCom: 'CX',
    vProd: 280.50,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 280.50,
    vIcms: 50.49,
  },
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231098765432000110550010000234562000234567',
    nNf: '23456',
    serie: '1',
    emissao: addDays(today, -30),
    cnpjEmitente: '11.222.333/0001-44',
    fornecedorNome: 'Medicamentos XYZ LTDA',
    ufEmitente: 'RJ',
    nItem: 1,
    xProd: 'IBUPROFENO 600MG 30 COMP',
    ncm: '30049099',
    lote: 'XYZ-456',
    dFab: addDays(today, -200),
    dVal: addDays(today, -5),
    qCom: 200,
    uCom: 'CX',
    vProd: 890.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 890.00,
    vIcms: 106.80,
  },
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231098765432000110550010000234562000234567',
    nNf: '23456',
    serie: '1',
    emissao: addDays(today, -30),
    cnpjEmitente: '11.222.333/0001-44',
    fornecedorNome: 'Medicamentos XYZ LTDA',
    ufEmitente: 'RJ',
    nItem: 2,
    xProd: 'AMOXICILINA 500MG 21 CAPS',
    ncm: '30042090',
    lote: 'XYZ-457',
    dFab: addDays(today, -190),
    dVal: addDays(today, 7),
    qCom: 150,
    uCom: 'CX',
    vProd: 725.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 725.00,
    vIcms: 87.00,
  },
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231055544433000122550010000345673000345678',
    nNf: '34567',
    serie: '1',
    emissao: addDays(today, -45),
    cnpjEmitente: '55.544.433/0001-22',
    fornecedorNome: 'Farmacêutica Brasil SA',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'OMEPRAZOL 20MG 28 CAPS',
    ncm: '30049099',
    lote: 'BRA-789',
    dFab: addDays(today, -210),
    dVal: addDays(today, 28),
    qCom: 300,
    uCom: 'CX',
    vProd: 1250.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 1250.00,
    vIcms: 225.00,
  },
  
  // Empresa 2 - Comércio Saúde
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231099988877000166550010000456784000456789',
    nNf: '45678',
    serie: '1',
    emissao: addDays(today, -10),
    cnpjEmitente: '98.765.432/0001-10',
    fornecedorNome: 'Distribuidora Pharma ABC',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'LOSARTANA POTASSICA 50MG 30 COMP',
    ncm: '30049039',
    lote: 'ABC-124',
    dFab: addDays(today, -160),
    dVal: addDays(today, 90),
    qCom: 180,
    uCom: 'CX',
    vProd: 980.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 980.00,
    vIcms: 176.40,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231099988877000166550010000456784000456789',
    nNf: '45678',
    serie: '1',
    emissao: addDays(today, -10),
    cnpjEmitente: '98.765.432/0001-10',
    fornecedorNome: 'Distribuidora Pharma ABC',
    ufEmitente: 'SP',
    nItem: 2,
    xProd: 'SINVASTATINA 20MG 30 COMP',
    ncm: '30049039',
    lote: 'ABC-125',
    dFab: addDays(today, -155),
    dVal: addDays(today, 120),
    qCom: 120,
    uCom: 'CX',
    vProd: 645.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 645.00,
    vIcms: 116.10,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231066655544000133550010000567895000567890',
    nNf: '56789',
    serie: '1',
    emissao: addDays(today, -20),
    cnpjEmitente: '66.655.544/0001-33',
    fornecedorNome: 'Med Import EIRELI',
    ufEmitente: 'MG',
    nItem: 1,
    xProd: 'METFORMINA 850MG 60 COMP',
    ncm: '30049039',
    lote: 'MED-2023-001',
    dFab: addDays(today, -170),
    dVal: addDays(today, 25),
    qCom: 250,
    uCom: 'CX',
    vProd: 1120.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 1120.00,
    vIcms: 134.40,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231066655544000133550010000567895000567890',
    nNf: '56789',
    serie: '1',
    emissao: addDays(today, -20),
    cnpjEmitente: '66.655.544/0001-33',
    fornecedorNome: 'Med Import EIRELI',
    ufEmitente: 'MG',
    nItem: 2,
    xProd: 'ATORVASTATINA 40MG 30 COMP',
    ncm: '30049039',
    lote: 'MED-2023-002',
    dFab: addDays(today, -165),
    dVal: addDays(today, 60),
    qCom: 90,
    uCom: 'CX',
    vProd: 780.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 780.00,
    vIcms: 93.60,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231077766655000144550010000678906000678901',
    nNf: '67890',
    serie: '1',
    emissao: addDays(today, -5),
    cnpjEmitente: '77.766.655/0001-44',
    fornecedorNome: 'Laboratório Nacional SA',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'CAPTOPRIL 25MG 30 COMP',
    ncm: '30049039',
    lote: 'LAB-NAC-500',
    dFab: addDays(today, -150),
    dVal: addDays(today, 180),
    qCom: 400,
    uCom: 'CX',
    vProd: 1560.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 1560.00,
    vIcms: 280.80,
  },

  // Empresa 3 - Farmácia Popular
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231088877766000155550010000789017000789012',
    nNf: '78901',
    serie: '1',
    emissao: addDays(today, -8),
    cnpjEmitente: '98.765.432/0001-10',
    fornecedorNome: 'Distribuidora Pharma ABC',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'HIDROCLOROTIAZIDA 25MG 30 COMP',
    ncm: '30049039',
    lote: 'ABC-126',
    dFab: addDays(today, -145),
    dVal: addDays(today, 10),
    qCom: 220,
    uCom: 'CX',
    vProd: 850.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 850.00,
    vIcms: 153.00,
  },
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231088877766000155550010000789017000789012',
    nNf: '78901',
    serie: '1',
    emissao: addDays(today, -8),
    cnpjEmitente: '98.765.432/0001-10',
    fornecedorNome: 'Distribuidora Pharma ABC',
    ufEmitente: 'SP',
    nItem: 2,
    xProd: 'ENALAPRIL 20MG 30 COMP',
    ncm: '30049039',
    lote: 'ABC-127',
    dFab: addDays(today, -140),
    dVal: addDays(today, 150),
    qCom: 180,
    uCom: 'CX',
    vProd: 720.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 720.00,
    vIcms: 129.60,
  },
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231011222333000144550010000890128000890123',
    nNf: '89012',
    serie: '1',
    emissao: addDays(today, -25),
    cnpjEmitente: '11.222.333/0001-44',
    fornecedorNome: 'Medicamentos XYZ LTDA',
    ufEmitente: 'RJ',
    nItem: 1,
    xProd: 'GLIBENCLAMIDA 5MG 30 COMP',
    ncm: '30049039',
    lote: 'XYZ-458',
    dFab: addDays(today, -185),
    dVal: addDays(today, 3),
    qCom: 160,
    uCom: 'CX',
    vProd: 590.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 590.00,
    vIcms: 70.80,
  },
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231011222333000144550010000890128000890123',
    nNf: '89012',
    serie: '1',
    emissao: addDays(today, -25),
    cnpjEmitente: '11.222.333/0001-44',
    fornecedorNome: 'Medicamentos XYZ LTDA',
    ufEmitente: 'RJ',
    nItem: 2,
    xProd: 'PROPRANOLOL 40MG 30 COMP',
    ncm: '30049039',
    lote: 'XYZ-459',
    dFab: addDays(today, -180),
    dVal: addDays(today, 35),
    qCom: 140,
    uCom: 'CX',
    vProd: 520.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 520.00,
    vIcms: 62.40,
  },
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231055544433000122550010000901239000901234',
    nNf: '90123',
    serie: '1',
    emissao: addDays(today, -35),
    cnpjEmitente: '55.544.433/0001-22',
    fornecedorNome: 'Farmacêutica Brasil SA',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'LEVOTIROXINA 50MCG 30 COMP',
    ncm: '30049039',
    lote: 'BRA-790',
    dFab: addDays(today, -195),
    dVal: addDays(today, 200),
    qCom: 280,
    uCom: 'CX',
    vProd: 1340.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 1340.00,
    vIcms: 241.20,
  },

  // Items without dVal (no expiration date)
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231033322211000199550010000012340000012345',
    nNf: '1234',
    serie: '1',
    emissao: addDays(today, -60),
    cnpjEmitente: '33.322.211/0001-99',
    fornecedorNome: 'Material Hospitalar Pro',
    ufEmitente: 'PR',
    nItem: 1,
    xProd: 'LUVA CIRURGICA ESTERIL TAM M',
    ncm: '40151900',
    lote: 'LUV-2023-100',
    dFab: addDays(today, -120),
    dVal: null,
    qCom: 500,
    uCom: 'CX',
    vProd: 2450.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 2450.00,
    vIcms: 294.00,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231044433322000177550010000023451000023456',
    nNf: '2345',
    serie: '1',
    emissao: addDays(today, -50),
    cnpjEmitente: '44.433.322/0001-77',
    fornecedorNome: 'Equipamentos Med LTDA',
    ufEmitente: 'RS',
    nItem: 1,
    xProd: 'TERMOMETRO DIGITAL INFRAVERMELHO',
    ncm: '90251180',
    lote: 'TERM-2023-A',
    dFab: addDays(today, -100),
    dVal: null,
    qCom: 30,
    uCom: 'UN',
    vProd: 1890.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 1890.00,
    vIcms: 226.80,
  },

  // More items for different scenarios
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231098765432000110550010000034562000034567',
    nNf: '3456',
    serie: '2',
    emissao: addDays(today, -40),
    cnpjEmitente: '98.765.432/0001-10',
    fornecedorNome: 'Distribuidora Pharma ABC',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'AZITROMICINA 500MG 3 COMP',
    ncm: '30042090',
    lote: 'ABC-200',
    dFab: addDays(today, -220),
    dVal: addDays(today, 5),
    qCom: 200,
    uCom: 'CX',
    vProd: 1200.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 1200.00,
    vIcms: 216.00,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231011222333000144550010000045673000045678',
    nNf: '4567',
    serie: '1',
    emissao: addDays(today, -12),
    cnpjEmitente: '11.222.333/0001-44',
    fornecedorNome: 'Medicamentos XYZ LTDA',
    ufEmitente: 'RJ',
    nItem: 1,
    xProd: 'NIMESULIDA 100MG 12 COMP',
    ncm: '30049099',
    lote: 'XYZ-500',
    dFab: addDays(today, -160),
    dVal: addDays(today, 20),
    qCom: 180,
    uCom: 'CX',
    vProd: 850.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 850.00,
    vIcms: 102.00,
  },
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231055544433000122550010000056784000056789',
    nNf: '5678',
    serie: '1',
    emissao: addDays(today, -18),
    cnpjEmitente: '55.544.433/0001-22',
    fornecedorNome: 'Farmacêutica Brasil SA',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'DICLOFENACO SODICO 50MG 20 COMP',
    ncm: '30049099',
    lote: 'BRA-791',
    dFab: addDays(today, -170),
    dVal: addDays(today, 12),
    qCom: 240,
    uCom: 'CX',
    vProd: 980.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 980.00,
    vIcms: 176.40,
  },
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231066655544000133550010000067895000067890',
    nNf: '6789',
    serie: '1',
    emissao: addDays(today, -22),
    cnpjEmitente: '66.655.544/0001-33',
    fornecedorNome: 'Med Import EIRELI',
    ufEmitente: 'MG',
    nItem: 1,
    xProd: 'VITAMINA D3 1000UI 30 CAPS',
    ncm: '30049099',
    lote: 'MED-2023-100',
    dFab: addDays(today, -200),
    dVal: addDays(today, 250),
    qCom: 300,
    uCom: 'CX',
    vProd: 1450.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 1450.00,
    vIcms: 174.00,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231077766655000144550010000078906000078901',
    nNf: '7890',
    serie: '1',
    emissao: addDays(today, -14),
    cnpjEmitente: '77.766.655/0001-44',
    fornecedorNome: 'Laboratório Nacional SA',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'CEFALEXINA 500MG 8 CAPS',
    ncm: '30042090',
    lote: 'LAB-NAC-501',
    dFab: addDays(today, -165),
    dVal: addDays(today, 18),
    qCom: 220,
    uCom: 'CX',
    vProd: 1120.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 1120.00,
    vIcms: 201.60,
  },
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231098765432000110550010000089017000089012',
    nNf: '8901',
    serie: '1',
    emissao: addDays(today, -7),
    cnpjEmitente: '98.765.432/0001-10',
    fornecedorNome: 'Distribuidora Pharma ABC',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'DEXAMETASONA 4MG 10 COMP',
    ncm: '30049099',
    lote: 'ABC-201',
    dFab: addDays(today, -155),
    dVal: addDays(today, 40),
    qCom: 160,
    uCom: 'CX',
    vProd: 720.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 720.00,
    vIcms: 129.60,
  },
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231011222333000144550010000090128000090123',
    nNf: '9012',
    serie: '1',
    emissao: addDays(today, -28),
    cnpjEmitente: '11.222.333/0001-44',
    fornecedorNome: 'Medicamentos XYZ LTDA',
    ufEmitente: 'RJ',
    nItem: 1,
    xProd: 'LORATADINA 10MG 12 COMP',
    ncm: '30049099',
    lote: 'XYZ-501',
    dFab: addDays(today, -175),
    dVal: addDays(today, 22),
    qCom: 190,
    uCom: 'CX',
    vProd: 820.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 820.00,
    vIcms: 98.40,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231055544433000122550010000001239000001234',
    nNf: '123',
    serie: '2',
    emissao: addDays(today, -33),
    cnpjEmitente: '55.544.433/0001-22',
    fornecedorNome: 'Farmacêutica Brasil SA',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'PREDNISONA 20MG 10 COMP',
    ncm: '30049099',
    lote: 'BRA-792',
    dFab: addDays(today, -188),
    dVal: addDays(today, 8),
    qCom: 210,
    uCom: 'CX',
    vProd: 920.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 920.00,
    vIcms: 165.60,
  },
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231066655544000133550010000002340000002345',
    nNf: '234',
    serie: '2',
    emissao: addDays(today, -16),
    cnpjEmitente: '66.655.544/0001-33',
    fornecedorNome: 'Med Import EIRELI',
    ufEmitente: 'MG',
    nItem: 1,
    xProd: 'RANITIDINA 150MG 20 COMP',
    ncm: '30049099',
    lote: 'MED-2023-101',
    dFab: addDays(today, -192),
    dVal: addDays(today, 14),
    qCom: 170,
    uCom: 'CX',
    vProd: 760.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 760.00,
    vIcms: 91.20,
  },
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231077766655000144550010000003451000003456',
    nNf: '345',
    serie: '2',
    emissao: addDays(today, -24),
    cnpjEmitente: '77.766.655/0001-44',
    fornecedorNome: 'Laboratório Nacional SA',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'FLUCONAZOL 150MG 1 CAPS',
    ncm: '30042090',
    lote: 'LAB-NAC-502',
    dFab: addDays(today, -182),
    dVal: addDays(today, 27),
    qCom: 250,
    uCom: 'CX',
    vProd: 1350.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 1350.00,
    vIcms: 243.00,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231098765432000110550010000004562000004567',
    nNf: '456',
    serie: '2',
    emissao: addDays(today, -19),
    cnpjEmitente: '98.765.432/0001-10',
    fornecedorNome: 'Distribuidora Pharma ABC',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'CLONAZEPAM 2MG 20 COMP',
    ncm: '30049099',
    lote: 'ABC-202',
    dFab: addDays(today, -168),
    dVal: addDays(today, 32),
    qCom: 140,
    uCom: 'CX',
    vProd: 680.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 680.00,
    vIcms: 122.40,
  },
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231011222333000144550010000005673000005678',
    nNf: '567',
    serie: '2',
    emissao: addDays(today, -11),
    cnpjEmitente: '11.222.333/0001-44',
    fornecedorNome: 'Medicamentos XYZ LTDA',
    ufEmitente: 'RJ',
    nItem: 1,
    xProd: 'SERTRALINA 50MG 30 COMP',
    ncm: '30049099',
    lote: 'XYZ-502',
    dFab: addDays(today, -158),
    dVal: addDays(today, 55),
    qCom: 190,
    uCom: 'CX',
    vProd: 910.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 910.00,
    vIcms: 109.20,
  },
  {
    empresaId: 1,
    empresaNome: 'TillBill Tecnologia LTDA',
    cnpjDestinatario: '12.345.678/0001-90',
    chaveNfe: '35231055544433000122550010000006784000006789',
    nNf: '678',
    serie: '2',
    emissao: addDays(today, -26),
    cnpjEmitente: '55.544.433/0001-22',
    fornecedorNome: 'Farmacêutica Brasil SA',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'ESCITALOPRAM 10MG 30 COMP',
    ncm: '30049099',
    lote: 'BRA-793',
    dFab: addDays(today, -172),
    dVal: addDays(today, 65),
    qCom: 180,
    uCom: 'CX',
    vProd: 890.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 890.00,
    vIcms: 160.20,
  },
  {
    empresaId: 2,
    empresaNome: 'Comércio Saúde LTDA',
    cnpjDestinatario: '98.765.432/0001-11',
    chaveNfe: '35231066655544000133550010000007895000007890',
    nNf: '789',
    serie: '2',
    emissao: addDays(today, -9),
    cnpjEmitente: '66.655.544/0001-33',
    fornecedorNome: 'Med Import EIRELI',
    ufEmitente: 'MG',
    nItem: 1,
    xProd: 'ÁCIDO FÓLICO 5MG 30 COMP',
    ncm: '30049099',
    lote: 'MED-2023-102',
    dFab: addDays(today, -162),
    dVal: addDays(today, 240),
    qCom: 260,
    uCom: 'CX',
    vProd: 1180.00,
    cfop: '6102',
    cstIcms: '000',
    pIcms: 12,
    vBcIcms: 1180.00,
    vIcms: 141.60,
  },
  {
    empresaId: 3,
    empresaNome: 'Farmácia Popular EIRELI',
    cnpjDestinatario: '11.222.333/0001-55',
    chaveNfe: '35231077766655000144550010000008906000008901',
    nNf: '890',
    serie: '2',
    emissao: addDays(today, -13),
    cnpjEmitente: '77.766.655/0001-44',
    fornecedorNome: 'Laboratório Nacional SA',
    ufEmitente: 'SP',
    nItem: 1,
    xProd: 'INSULINA NPH 100UI/ML 10ML',
    ncm: '30043110',
    lote: 'LAB-NAC-600',
    dFab: addDays(today, -150),
    dVal: addDays(today, 6),
    qCom: 80,
    uCom: 'FR',
    vProd: 2450.00,
    cfop: '5102',
    cstIcms: '060',
    pIcms: 18,
    vBcIcms: 2450.00,
    vIcms: 441.00,
  },
];

// Mock empresas for selector
export const mockEmpresas = [
  {
    value: 1,
    label: 'TillBill Tecnologia LTDA',
    cnpj: '12.345.678/0001-90',
  },
  {
    value: 2,
    label: 'Comércio Saúde LTDA',
    cnpj: '98.765.432/0001-11',
  },
  {
    value: 3,
    label: 'Farmácia Popular EIRELI',
    cnpj: '11.222.333/0001-55',
  },
];
